import React from "react";
import type { FC } from "react";

import { Badge } from "../../../../Badge";
import { createDisplayNameForContentElement } from "../../utils/getDisplayName";
import { createTestIdForContentElement } from "../../utils/getTestId";

import type { OmitOfUnion } from "../../../../../types/react";
import type { BadgeProps } from "../../../../Badge";

const CONTENT_BADGE_TEST_ID = createTestIdForContentElement("badge");

type ConstantBadgeProps = "size";

type ContentBadgeProps = OmitOfUnion<BadgeProps, ConstantBadgeProps>;

export const ContentBadge: FC<ContentBadgeProps> = (props) => {
    return (
        <Badge {...(props as BadgeProps)} data-tsid={CONTENT_BADGE_TEST_ID} />
    );
};

ContentBadge.displayName = createDisplayNameForContentElement("Badge");

export default ContentBadge;
